




































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { SummaryModel } from "@/shared/models/reportModels";
import ReportLineChart from "@/components/chart-components/ReportLineChart.vue";
import PaceReportChart from "@/components/chart-components/PaceReportChart.vue";
import ChannelTypeChart from "@/components/chart-components/ChannelTypeChart.vue";
import ReportSettingsModal from "@/components/misc/ReportSettingsModal.vue";
import NoData from "@/components/misc/NoData.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import { DateTime } from "luxon";
import { saveFile } from "@/shared/saveFile";
import { formatLocaleNumber } from "@/components/numbers/numberFormatUtils";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { JwtClaims } from "@/store/modules/auth";
import { RolesEnum, userHasAnyRole } from "@/shared/roles";

@Component({
  components: {
    NoData,
    ReportLineChart,
    PaceReportChart,
    ChannelTypeChart,
    ReportSettingsModal,
    ScrollLoader,
  },
})
export default class ReportTilesMobile extends Vue {
  achieved: SummaryModel = new SummaryModel();
  projections: SummaryModel = new SummaryModel();

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;

  @Getter("language/language") language?: string;

  @Getter("codebooks/currencies") currencies?: Currency[];
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/formalCurrency") formalCurrency?: Currency;

  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];
  @Action("codebooks/refreshDistributionChannelTypes")
  refreshDistributionChannelTypes?: () => Promise<void>;
  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;

  @Getter("auth/claims") claims?: JwtClaims;

  get isOwnerLevel3() {
    return userHasAnyRole([RolesEnum.PropertyOwnerLevel3, RolesEnum.PropertyOwnerLevel3a])(this.claims);
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  loadOrderNumber = 1;

  get loadOrder() {
    return this.loadOrderNumber;
  }

  displayBody: HTMLElement | null = null;

  loadingAchieved = true;
  loadingProjections = true;
  downloadingExcel = false;

  settingsModalOpen = false;
  modalType = "";

  get settingsModalType() {
    return this.modalType;
  }

  get settingsModalOptions() {
    return this.settingsModalType === "achieved"
      ? this.achievedOptions
      : this.projectionsOptions;
  }

  async created() {
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      await this.refreshCurrencies();
    }

    if (
      (this.distributionChannelTypes?.length ?? 0) === 0 &&
      this.refreshDistributionChannelTypes
    ) {
      await this.refreshDistributionChannelTypes();
    }

    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      await this.refreshSalesChannels();
    }
  }

  mounted() {
    this.displayBody = this.$refs.displayBody as HTMLElement;
    this.firstLoad();
  }

  async firstLoad() {
    await this.loadAchieved();
    await this.loadProjections();
    if (this.displayBody) {
      if (
        this.displayBody.scrollHeight > 0 &&
        this.displayBody.scrollHeight == this.displayBody.clientHeight
      ) {
        this.loadMore();
      }
    }
  }

  loadMore() {
    if (this.loadOrderNumber < 7) {
      this.loadOrderNumber += 1;
    }
  }

  get achievedFromDate() {
    return this.$d(new Date(this.achievedOptions.from)).replace(/\s/g, "");
  }

  get achievedToDate() {
    return this.$d(new Date(this.achievedOptions.to)).replace(/\s/g, "");
  }

  get projectionsFromDate() {
    return this.$d(new Date(this.projectionsOptions.from)).replace(/\s/g, "");
  }

  get projectionsToDate() {
    return this.$d(new Date(this.projectionsOptions.to)).replace(/\s/g, "");
  }

  achievedOptions = {
    from: DateTime.local().startOf("year").toString().substr(0, 10),
    to: DateTime.local().toString().substr(0, 10),
    accUnitTypeIds: [] as number[],
  };

  projectionsOptions = {
    excludeHolds: true,
    from: DateTime.local().plus({ days: 1 }).toString().substr(0, 10),
    to: DateTime.local().endOf("year").toString().substr(0, 10),
    accUnitTypeIds: [] as number[],
  };

  downaloadExcel() {
    this.downloadingExcel = true;
    return this.axios
      .get("Reports/GetReservationsExcelReport", {
        params: {},
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Customers.xlsx");
      })
      .finally(() => {
        this.downloadingExcel = false;
      });
  }

  async loadAchieved() {
    this.loadingAchieved = true;
    await Vue.axios
      .get<SummaryModel>("Reports/GetSummaryReport", {
        params: {
          excludeHolds: false,
          from: this.achievedOptions.from,
          to: this.achievedOptions.to,
          accUnitTypeIds: this.achievedOptions.accUnitTypeIds.join(","),
        },
      })
      .then((res) => {
        this.achieved = res.data;
      })
      .finally(() => {
        this.loadingAchieved = false;
      });
  }

  async loadProjections() {
    this.loadingProjections = true;
    await Vue.axios
      .get<SummaryModel>("Reports/GetSummaryReport", {
        params: {
          excludeHolds: this.projectionsOptions.excludeHolds,
          from: this.projectionsOptions.from,
          to: this.projectionsOptions.to,
          accUnitTypeIds: this.achievedOptions.accUnitTypeIds.join(","),
        },
      })
      .then((res) => {
        this.projections = res.data;
      })
      .finally(() => {
        this.loadingProjections = false;
      });
  }

  formatNumbers(val: any) {
    return formatLocaleNumber(val, 0, this.internalLanguage);
  }

  formatAvgStayLength(val: number) {
    return val.toString().replace(".", ",");
  }

  formatPercentage(val: number) {
    return this.formatNumbers(val * 100) + "%";
  }

  openSettingsModal(val: string) {
    this.modalType = val;
    this.settingsModalOpen = true;
  }

  updateSettings(settings: any) {
    if (this.settingsModalType === "achieved") {
      this.achievedOptions.from =
        settings.fromToDate[0] ??
        DateTime.local().startOf("year").toString().substr(0, 10);
      this.achievedOptions.to =
        settings.fromToDate[1] ?? DateTime.local().toString().substr(0, 10);
      this.achievedOptions.accUnitTypeIds = settings.accUnitTypeIds;

      this.loadAchieved();
    }

    if (this.settingsModalType === "projections") {
      this.projectionsOptions.excludeHolds = settings.excludeHolds;
      this.projectionsOptions.from =
        settings.fromToDate[0] ?? DateTime.local().toString().substr(0, 10);
      this.projectionsOptions.to =
        settings.fromToDate[1] ??
        DateTime.local().endOf("year").toString().substr(0, 10);
      this.achievedOptions.accUnitTypeIds = settings.accUnitTypeIds;

      this.loadProjections();
    }
  }
}
